<template>
  <div
    class="call-phone-nav"
    :class="{ dark: $route.meta && $route.meta.darkMode }"
    v-if="isOpen"
  >
    <div class="nav-item" :class="{ active: active }" @click="handleClick">
      <!-- <template v-if="!active"> -->
      <img
        class="title-icon"
        src="~@/assets/image/icons/icon-mask-dark.png"
        alt=""
        srcset=""
        v-if="$route.meta && $route.meta.darkMode"
      />
      <img
        class="title-icon"
        src="~@/assets/image/icons/icon-mask.png"
        alt=""
        srcset=""
        v-else
      />
      <!-- </template> -->

      <!-- <span class="title-icon" v-else>☎️</span> -->
      <div>
        <div class="calling">
          {{ active && !isCalling ? '有來電 請接聽' : '匿名熱線(試營運)' }}
          <span class="icon-phone" v-if="active">
            ☎️
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { checkOrder } from './api';
import AnonymousCallProvider from '@/components/AnonymousCall/anonymousCall';

export default {
  name: 'CallPhone',
  props: {},
  data() {
    return {
      active: false,
      timer: null,
      roomUid: null,
      status: null,
      isAnonymousCalling: false, //是否有正在打开的匿名通话页面
      tabId: String(Math.random()),
      allowNotifications: false,
      getDetailLoading: false,
      pageStatus: 0, // 0常态 1有来电 2有来电，点击后的状态
      AnonymousCallProvider,
      currentTime: new Date(),
      openTimer: null
    };
  },
  watch: {
    active: {
      handler: function(nVal, oVal) {
        this.AnonymousCallProvider.setOncall(nVal);
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isPlayer() {
      return this.userInfo && this.userInfo.userKind === 'Player';
    },
    isCalling() {
      return (
        (this.AnonymousCallProvider.state == 1 ||
          this.AnonymousCallProvider.state == 2) &&
        this.$route.name == 'AnonymousCall'
      );
    },
    isOpen() {
      const hours = this.currentTime.getHours();
      return hours >= 20 || hours < 2;
    }
  },
  methods: {
    handleClick() {
      this.toAnonymousCallPage()
    },

    toAnonymousCallPage() {
      if (this.isCalling) {
        return;
      }
      if (this.active) {
        if (this.$route.name == 'VoiceRoom' || this.$route.name == 'GameRoom') {
          this.$confirm({
            content: '您將離開語音廳，確認接通嗎?',
            confirmButtonText: '確定',
            className: 'custom-draw-dialog',
            showCancelButton: true,
            closeOnClickModal: false
          }).then(() => {
            this.$router.push({ name: 'AnonymousCalling' });
          });
        } else {
          this.$router.push({ name: 'AnonymousCalling' });
        }
      } else {
        this.$router.push({ name: 'AnonymousCall' });
      }
    },

    async getDetail() {
      this.timer = setInterval(async () => {
        console.log(
          'getDetail',
          this.allowNotifications,
          this.getDetailLoading,
          this.isAnonymousCalling
        );
        if (!this.isOpen) {
          return;
        }
        if (!this.userInfo) {
          return;
        }
        if (this.getDetailLoading) {
          return;
        }
        if (this.allowNotifications) {
          this.getDetailLoading = true;
          try {
            // if (this.$route.name == 'AnonymousCall') {
            //   this.active = false;
            //   return;
            // }

            localStorage.setItem('checkAnonymousCalling', Math.random());
            this.isAnonymousCalling = !!localStorage.getItem(
              'anonymousCalling'
            );
            if (this.isAnonymousCalling) {
              localStorage.setItem('anonymousCalling', '');
              this.active = false;
              return;
            }
            console.log('checkOrder');

            const { data } = await checkOrder();
            const { roomUid, status } = data;
            this.roomUid = roomUid;
            this.status = status;
            if ((this.status === 1 || this.status === 2) && !this.isCalling) {
              this.active = true;
              // this.setNotify();
            } else {
              this.active = false;
            }
          } catch (error) {
            this.active = false;
          } finally {
            this.getDetailLoading = false;
          }
        } else {
          this.active = false;
        }
      }, 3000);
    },

    handleDocumentClick() {
      this.isClick = true;
      document.removeEventListener('click', this.handleDocumentClick);
    },

    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.setTabId();
      }
    },

    handleFocusChange() {
      this.setTabId();
    },

    setTabId() {
      localStorage.setItem('anonymousCallTabId', this.tabId);
      this.allowNotifications = true;
    }
  },
  created() {
    window.onstorage = e => {
      // if (e.key === 'anonymousCalling') {
      //   this.isAnonymousCalling = !!e.newValue;
      // }
      if (e.key === 'anonymousCallTabId') {
        if (this.tabId == e.newValue) {
          this.allowNotifications = true;
        } else {
          this.allowNotifications = false;
        }
      }
    };
    this.setTabId();
    this.openTimer = setInterval(() => {
      this.currentTime = new Date();
    }, 60000);
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    document.addEventListener('focus', this.handleFocusChange);
    this.getDetail();
  },
  beforeDestroy() {
    // 移除全局文档点击事件监听器
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('focus', this.handleFocusChange);
    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange
    );
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.openTimer) {
      clearInterval(this.openTimer);
    }
  }
};
</script>
<style lang="scss" scoped>
@keyframes shake {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
.call-phone-nav {
  &.dark {
    color: #8c94aa;
    .nav-item {
      color: #8c94aa;
    }
    .btn-call {
      color: white;
    }
    .btn2 {
      color: #8c94aa;
    }
  }
}
.btn-call {
  background: #19cb1c;
  border-radius: 1197.19px;
  width: 100%;
  padding: 4px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
  flex: none;
  color: white;
  .icon-call {
    width: 10px;
    margin-right: 10px;
  }
}
.btn2 {
  font-size: 12px;
  color: #a9a9a9;
  //  border-radius: 1000px
}
.nav-item {
  @include flex(flex-start);
  position: relative;
  min-height: 56px;
  padding: 10px 10px 10px 24px;
  color: $color-gray-1;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: rgba($color: $color-split, $alpha: 0.4);
  }
  &.active {
    // .title-icon {
    //   animation: shake 0.5s infinite;
    //   font-size: 16px;
    //   margin: 0 14px 0 13px;
    // }
    .title-icon {
      margin-right: 8px;
    }
    color: #86d97b;
    // background-color: #86d97b;
    // color: black;
    .icon-phone {
      animation: shake 0.5s infinite;
    }
    .calling {
      background-color: #19cb1c;
      color: white;
      padding: 4px 8px 4px 16px;
      border-radius: 100px;
      display: flex;
      align-items: center;
    }
  }
  .title-icon {
    width: 24px;
    height: 24px;
    line-height: 24px;
    margin: 0 20px 0 8px;
    font-size: 12px;
  }
  .icon-phone {
    font-size: 12px;
    margin-left: 4px;
    width: 24px;
    height: 24px;
    line-height: 24px;
    display: inline-block;
  }
}
</style>
